import { Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';

import AliasInput from 'components/AliasInput/AliasInput';
import { useTranslation } from 'react-i18next';
import { FieldTemplateFormProps } from '.';

export function StringFieldTemplate({
  formik,
  disabled,
  isRepeatingFieldsEnabled,
}: FieldTemplateFormProps) {
  const { t } = useTranslation();

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={`${t('forms.fieldAttributes.label')} *`}
            type="text"
            name="label"
            value={formik.values.label}
            onChange={formik.handleChange}
            error={formik.touched.label && Boolean(formik.errors.label)}
            InputLabelProps={{
              shrink: true,
            }}
            helperText={formik.touched.label && formik.errors.label}
          />
        </Grid>

        <Grid item xs={3} display={'flex'} alignItems={'center'}>
          <FormControlLabel
            disabled={disabled}
            control={<Checkbox />}
            label={`${t('forms.fieldAttributes.isRequired')}`}
            checked={formik.values.isRequired}
            onChange={() => {
              formik.setFieldValue('isRequired', !formik.values.isRequired);
            }}
          />
        </Grid>

        <Grid item xs={3} display={'flex'} alignItems={'center'}>
          {isRepeatingFieldsEnabled && (
            <FormControlLabel
              disabled={disabled}
              control={<Checkbox />}
              label={`${t('forms.fieldAttributes.isRepeatable')}`}
              checked={formik.values.isRepeatable}
              onChange={() => {
                formik.setFieldValue(
                  'isRepeatable',
                  !formik.values.isRepeatable,
                );
              }}
            />
          )}
        </Grid>

        <Grid item xs={6}>
          <AliasInput
            disabled={disabled}
            type="text"
            name="alias"
            value={formik.values.alias}
            onChange={formik.handleChange}
            fullWidth
            error={formik.touched.alias && Boolean(formik.errors.alias)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            label={t('forms.fieldAttributes.defaultValue')}
            type="text"
            name="defaultValue"
            value={formik.values.defaultValue}
            onChange={formik.handleChange}
            fullWidth
            error={
              formik.touched.defaultValue && Boolean(formik.errors.defaultValue)
            }
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ mt: 1 }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.unit')}
            type="unit"
            name="unit"
            value={formik.values.unit}
            onChange={formik.handleChange}
            error={formik.touched.unit && Boolean(formik.errors.unit)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.minLength')}
            type="number"
            name="minLength"
            value={formik.values.minLength}
            onChange={formik.handleChange}
            error={formik.touched.minLength && Boolean(formik.errors.minLength)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.maxLength')}
            type="number"
            name="maxLength"
            value={formik.values.maxLength}
            onChange={formik.handleChange}
            error={formik.touched.maxLength && Boolean(formik.errors.maxLength)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.visibleLineCount')}
            type="number"
            name="visibleLineCount"
            value={formik.values.visibleLineCount}
            onChange={formik.handleChange}
            error={
              formik.touched.visibleLineCount &&
              Boolean(formik.errors.visibleLineCount)
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.description')}
            type="text"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            multiline
            rows={3}
            error={
              formik.touched.description && Boolean(formik.errors.description)
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
}
